<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">стандартный заголовок</slot>
        </div>

        <div class="modal-body">
          <slot name="body">тело по умолчанию</slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <DiveButton
              class="modal-default-button"
              text="Да"
              type="primary"
              size="medium"
              @click="$emit('close')"
            />
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import DiveButton from '@/shared/ui/DiveButton.vue';
export default {
  components: {
    DiveButton,
  },
  props: {
    show: Boolean,
  },
  emits: ['close'],
};
</script>

<style>
.modal-mask {
  font-family: 'Raleway', sans-serif;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 350px;
  margin: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h1 {
  margin-top: 0;
  color: #0a7cff;
  font-size: 24px;
}

.modal-body {
  margin: 10px 0;
  font-size: 18px;
}

.modal-default-button {
  float: right;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
